import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

interface ExpressCosts {
  remera_cost: number;
  buzo_cost: number;
  estampado_cost: number;
}

export const useExpressCosts = () => {
  const [costs, setCosts] = useState<ExpressCosts>({
    remera_cost: 0,
    buzo_cost: 0,
    estampado_cost: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCosts = async () => {
      try {
        setIsLoading(true);
        setError(null);
        
        const { data, error: fetchError } = await supabase
          .from('express_costs')
          .select('*')
          .limit(1);
        
        if (fetchError) throw fetchError;
        
        if (data && data.length > 0) {
          setCosts({
            remera_cost: data[0].remera_cost || 0,
            buzo_cost: data[0].buzo_cost || 0,
            estampado_cost: data[0].estampado_cost || 0,
          });
        }
      } catch (err: any) {
        console.error('Error fetching express costs:', err);
        setError(err.message || 'Error al obtener los costos');
      } finally {
        setIsLoading(false);
      }
    };

    fetchCosts();
  }, []);

  return { costs, isLoading, error };
};
